<template>
  <div style="height: inherit">
    <v-style>
      @media screen and (max-width: 599px) { .v-timeline:after{ height: calc(100% - {{ dtimelineMemberLvl >= 1 ? dtimelineMemberLvl * 85 + 40 : 0 }}px) !important; top :
      {{ dtimelineMemberLvl >= 1 ? dtimelineMemberLvl * 85 + 40 : 0 }}px !important; }

      <!--        .v-timeline:after{-->
      <!--          {{ timelineHeight }}-->
      <!--          {{$data._top}}-->
      <!--        }-->

      } @media screen and (min-width:600px) and (max-width: 959px) { .v-timeline:after{ height: calc(100% - {{ dtimelineMemberLvl >= 1 ? dtimelineMemberLvl * 110 + 50 : 0 }}px) !important; top :
      {{ dtimelineMemberLvl >= 1 ? dtimelineMemberLvl * 110 + 50 : 0 }}px !important; } }
    </v-style>
    <v-snackbar class="pa-0" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'check_circle' : 'cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <v-card class="vip-card justify-center">
      <!--      <v-row no-gutters justify="center" class="hidden-md-and-down" :class="$vuetify.breakpoint.mdAndUp ? 'mt-16 mb-8' : 'mx-2 mt-8 mb-8'">-->
      <!--        <v-col cols="12" md="6" lg="5">-->
      <!--          <v-card class="vip-progress-card mt-8" elevation="0" v-if="isLoggedIn">-->
      <!--            <v-row no-gutters align="end" class="px-8 pt-4">-->
      <!--              <v-col>-->
      <!--                <v-row no-gutters justify="center">-->
      <!--                  <v-col cols="12" class="text-left mb-1 ml-2">-->
      <!--                    <label class="white&#45;&#45;text font-weight-bold" :class="$vuetify.breakpoint.xsOnly ? 'subtitle-1' : 'title'">{{ vipProgress.current_level_name }}</label>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col cols="1" md="1" class="text-left">-->
      <!--                    &lt;!&ndash; <v-avatar :size="$vuetify.breakpoint.xsOnly ? 50 : 64" class="vip-process-bar-icon">-->
      <!--                      <img src="/static/image/icon/vip-level-icon.png" />-->
      <!--                    </v-avatar> &ndash;&gt;-->
      <!--                    <v-avatar class="vip-process-bar-icon" :size="$vuetify.breakpoint.xsOnly ? '50' : '64'">-->
      <!--                      <img src="/static/image/icon/vip-level-no.png" />-->
      <!--                      <span class="centered white&#45;&#45;text">{{ currentLvlCode }}</span>-->
      <!--                    </v-avatar>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="11" md="11">-->
      <!--                    <v-progress-linear :height="$vuetify.breakpoint.xsOnly ? 35 : 45" class="vip-progress-bar" :value="vipProgressPercentage">-->
      <!--                      <template v-slot:default="{ value }">-->
      <!--                        <label v-if="vipProgress.member_progress_type == 2">{{ vipProgress.current_deposit_progress }} / {{ vipProgress.required_deposit_amount }}</label>-->
      <!--                        <label v-if="vipProgress.member_progress_type == 3">{{ vipProgress.current_rollover_progress }} / {{ vipProgress.required_account_rollover }}</label>-->
      <!--                      </template>-->
      <!--                    </v-progress-linear>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--            <v-row justify="center" no-gutters class="px-8 pt-4">-->
      <!--              <v-col cols="6" class="mb-6" :class="$vuetify.breakpoint.lgAndUp ? ($vuetify.breakpoint.xlOnly ? 'pr-10' : 'pr-5') : 'pr-2'">-->
      <!--                <app-button class="ml-1 dialog-button" :disabled="!isApplicable" :action="applyVipBonus" :title="$t(`button.vipSpecial`) + bonusPercentage"></app-button>-->
      <!--              </v-col>-->
      <!--              <v-col class="text-center" cols="6" :class="$vuetify.breakpoint.lgAndUp ? ($vuetify.breakpoint.xlOnly ? 'pl-10' : 'pl-5') : 'pl-2'">-->
      <!--                <app-button class="dialog-button mr-2" :disabled="!vipProgress.has_pending_claim" :action="claimVipProgress" :title="$t(`button.claimVip`)"></app-button>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--          </v-card>-->
      <!--          <v-card class="vip-progress-card mt-8" elevation="0" v-else>-->
      <!--            <v-row no-gutters align="end" class="px-8 pt-4">-->
      <!--              <v-col>-->
      <!--                <v-row no-gutters justify="center">-->
      <!--                  <v-col cols="12" class="text-center">-->
      <!--                    <label class="white&#45;&#45;text font-weight-bold" :class="$vuetify.breakpoint.xsOnly ? 'subtitle-1' : 'title'">-->
      <!--                      {{ $t(`label.vipLogin`) }}-->
      <!--                    </label>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="12" class="text-center my-8">-->
      <!--                    <label class="white&#45;&#45;text font-weight-bold subtitle-1">{{ $t(`label.vipLoginBenefit`) }}</label>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row no-gutters justify="center">-->
      <!--                  <v-col cols="6" sm="5" class="mb-6 text-center">-->
      <!--                    <v-btn-->
      <!--                      height="auto"-->
      <!--                      @click="this.goToLoginPage"-->
      <!--                      color="black"-->
      <!--                      class="mr-6 primary-button pa-2 font-weight-bold yellow&#45;&#45;text"-->
      <!--                      :class="$vuetify.breakpoint.xsOnly ? 'vip-mobile-login-button' : 'embedded-login-button'"-->
      <!--                    >-->
      <!--                      {{ $t(`button.login`) }}-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                  <v-col class="text-center" sm="5" cols="6">-->
      <!--                    <app-button-->
      <!--                      :customClass="'buttonPrimary subtitle-1 full-width font-weight-bold pa-2 theme-button embedded-register-button'"-->
      <!--                      :action="this.goToRegisterPage"-->
      <!--                      :title="$t(`label.signUp`)"-->
      <!--                    ></app-button>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--          </v-card>-->
      <!--        </v-col>-->
      <!--      </v-row>-->

      <v-row no-gutters justify="center" class="betting-pass-header-details" :class="$vuetify.breakpoint.smAndUp ? 'mt-16 mb-8' : 'mx-2 mt-8 mb-8'">
        <v-col cols="12" md="9" lg="9">
          <div class="betting-pass-banner-container">
            <img src="/static/image/betting-pass/tiger.png" class="betting-pass-tiger hidden-sm-and-down" />
            <div class="betting-pass-banner" :style="{ backgroundImage: `url(${bettingPassBanner})` }">
              <div class="betting-pass-content">
                <span class="title-1">{{ $t(`label.bettingPassBannerTitle`) }}</span>
                <span class="title-2">{{ $t(`label.bettingPassBannerTitle2`) }}</span>
                <span class="content hidden-sm-and-down">{{ $t(`label.bettingPassBannerContent`) }}</span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" lg="3" class="betting-pass-level-container">
          <img src="/static/image/betting-pass/treasure.png" class="betting-pass-treasure  hidden-sm-and-down" />
          <v-card class="vip-progress-card" elevation="0" v-if="isLoggedIn" :class="isLoggedIn ? 'logged-in' : ''">
            <v-row no-gutters align="end" class="px-3 pt-4">
              <v-col cols="12">
                <span class="vip-progress-text mobile ">{{ $t(`label.bettingPassProgress`) }}</span>
              </v-col>
              <v-col class="mobile-logged-details">
                <v-row no-gutters justify="center" class="mobile-logged-level">
                  <v-col cols="12" class="text-center vip-level">
                    <span class="white--text font-weight-bold">{{ currentLvlCode }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters class="progress-bar-details">
                  <v-col cols="12">
                    <span class="vip-progress-text hidden-sm-and-down ">{{ $t(`label.bettingPassProgress`) }}</span>
                  </v-col>
                  <v-col cols="12">
                    <div class="vip-progress-bar-text">
                      <span v-if="vipProgress.member_progress_type == 2">{{ vipProgress.current_deposit_progress }} / {{ vipProgress.required_deposit_amount }}</span>
                      <span v-if="vipProgress.member_progress_type == 3">{{ vipProgress.current_rollover_progress }} / {{ vipProgress.required_account_rollover }}</span>
                    </div>
                    <v-row class="mobile-gutter">
                      <v-col cols="12">
                        <v-progress-linear :height="$vuetify.breakpoint.smAndDown ? 13 : 10" class="vip-progress-bar" :value="vipProgressPercentage"></v-progress-linear>
                      </v-col>
                    </v-row>
                    <div class="progress-node-desc">
                      <span class="vip-current-level-text">{{ vipProgress.current_level_name }}</span>
                      <span class="vip-next-level-text">{{ vipProgress.next_level_name }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters class="px-3 pt-4 deposit-desc-btn">
              <v-col class="clos">
                <span class="vip-progress-text">{{ $t(`label.bettingPassDepositNow`) }}</span>
              </v-col>
              <v-col cols="12">
                <app-button class="white--text dialog-button " custom-class="betting-pass-deposit-button" :action="goToDepost" :title="$t(`label.depositNow`)"></app-button>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="vip-progress-card" elevation="0" style="" v-else>
            <v-row no-gutters align="end" class="px-3 pt-3">
              <v-col>
                <v-row no-gutters justify="center">
                  <v-col cols="12" class="my-2">
                    <span class="white--text betting-pass-login-text">{{ $t(`label.bettingPassLogin`) }}</span>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="center">
                  <v-col class="text-center" cols="12">
                    <app-button :customClass="' subtitle-1 full-width pa-2 theme-button betting-pass-register-button'" :action="this.goToRegisterPage" :title="$t(`label.register`)"></app-button>
                  </v-col>
                  <v-col cols="12" class="mb-6 text-center">
                    <v-btn
                      height="auto"
                      @click="this.goToLoginPage"
                      class="buttonPrimary primary-button pa-1  full-width"
                      :class="$vuetify.breakpoint.xsOnly ? 'vip-mobile-login-button' : 'betting-pass-login-button'"
                    >
                      {{ $t(`button.login`) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!--      desktop+mobile responsive view-->
      <div class="" :class="$vuetify.breakpoint.mdAndUp ? 'mt-16 mb-8' : 'mx-2 mt-8 mb-8'">
        <v-card style="background: transparent !important">
          <v-card class="betting-pass-summary-table" elevation="0">
            <v-row align="center" no-gutters class="betting-pass-prizes-row" id="betting-pass-prizes-row">
              <v-col md="2" lg="2" v-for="(reward, index) in currrentVipSummary" class="mobile-prize-card">
                <div class="betting-pass-reward-container" :id="`prize_` + (index + 1)">
                  <span class="betting-pass-reward-level-text">{{ 'Level ' + reward.level }}</span>
                  <img class="betting-pass-reward-img" :src="getDisplayIcon(reward)" />
                  <span class="betting-pass-reward-text" v-if="reward.reward_type == 'COINS'">
                    {{ $t(`label.free`) + ' ' + currencySymbolMapp(currentCurrency) + reward.text }}
                  </span>
                  <span class="betting-pass-reward-text" v-else-if="reward.reward_type == 'BONUS'">
                    {{ reward.text + ' ' + $t(`label.bonus`) }}
                  </span>
                  <span class="betting-pass-reward-text" v-else-if="reward.reward_type == 'GIFT'">
                    {{ reward.text }}
                  </span>
                  <v-divider class="betting-pass-reward-divider"></v-divider>
                  <span class="betting-pass-requirements-text">
                    {{ currencyFormatter(reward.requirements, currentCurrency, true) }}
                  </span>
                </div>
                <v-col class="text-center" cols="12">
                  <app-button
                    v-if="vipProgress.has_pending_claim"
                    :custom-class="`buttonPrimary theme-button theme--light betting-pass-reward-button
                    ${currentLvlCode > reward.level ? 'claimed-betting-pass-reward-button' : ''}`"
                    :disabled="currentLvlCode >= reward.level ? false : true"
                    :action="currentLvlCode == reward.level ? claimVipProgress: ''"
                    :title="currentLvlCode > reward.level ? '✓': $t(`button.claimBettingPass`)"
                  ></app-button>
                  <app-button
                    v-else
                    :custom-class="`buttonPrimary theme-button theme--light betting-pass-reward-button
                    ${currentLvlCode > reward.level ? 'claimed-betting-pass-reward-button' : ''}`"
                    :disabled="currentLvlCode > reward.level ? false : true"
                    :action="claimVipProgress"
                    :title="currentLvlCode > reward.level ? '✓': $t(`button.claimBettingPass`)"
                  ></app-button>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </div>
      <v-row no-gutters style="padding-bottom: 70px;">
        <v-col cols="12" class="text-center mb-md-6" v-if="pagination.totalPage > 1">
          <v-pagination
            dark
            circle
            class="vip_summary_pagination"
            v-model="pagination.currentPage"
            :length="pagination.totalPage"
            @input="changePage"
            :next-icon="'arrow_forward_ios'"
            :prev-icon="'arrow_back_ios'"
            :total-visible="pagination.paginationPageLimit"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { BONUS_LIST, VIP_BONUS_APPLY, VIP_BONUS_CHECK, VIP_BONUS_RESET, VIP_CLAIM_REWARD, VIP_RESET_CLAIM, VIP_REWARDS_SUMMARY, VOUCHER_BONUS_CHECK } from '../../store/bonus.module'
import { MEMBER_GET_VIP_PROGRESS } from '../../store/member.module'
import { VipClaimType } from '../../constants/enums'
import { ROUTE_NAME } from '../../constants/route.constants'
import { locale, errorCodeHelper, uiHelper } from '@/util'
import currencySymbolMapp from 'currency-symbol-map'
import { SHARED } from '@/constants/constants'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import currencyFormat from "@/filters/currency-format";

export default {
  name: 'vipPage',
  data: () => ({
    currencyFormatter: currencyFormat,
    bonusPercentage: '',
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    language: uiHelper.getLanguage(),
    pagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 10
    },
    currrentVipSummary: [],
    searchCriteria: {
      pageNumber: 1,
      pageSize: 6,
      mobilePageSize: 6
    },
    currentCurrency: uiHelper.getCurrency(),
    currencySymbolMapp: currencySymbolMapp,
    alertShow: false,
    alertSuccess: true,
    alertMessage: '',
    testPendingClaim: false,
    dtimelineMemberLvl: 0
  }),
  components: {
    AppLoginEmbedded
  },
  computed: {
    bannerLanguage() {
      return ['enin', 'enne', 'enpk'].includes(this.language) ? 'en' : this.language
    },
    bettingPassBanner() {
      return `${this.mediaUrl}/banners/betting_pass/${this.$vuetify.breakpoint.smAndDown ? 'mobile' : 'desktop'}/${this.bannerLanguage}.jpg`
    },
    timelineHeight() {
      return this._height
    },
    bonusList() {
      return this.$store.state.bonus.bonusList
    },
    isApplicable() {
      return this.$store.state.bonus.vipBonusCheckResult.data.available
    },
    applyComplete() {
      return this.$store.state.bonus.vipBonusApplyResult.complete
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    vipClaimComplete() {
      return this.$store.state.bonus.vipProgressClaimResult.complete
    },
    vipRewardsSummaryData() {
      return this.$store.state.bonus.vipRewardsSummary
    },
    vipClaimType() {
      switch (this.vipProgress.member_progress_type) {
        case VipClaimType.BOTH:
          return 'Rollover and Deposit'
        case VipClaimType.DEPOSIT_ONLY:
          return 'Deposit Only'
        case VipClaimType.ROLLOVER_ONLY:
          return 'Rollover Only'
      }
    },
    vipProgressPercentage() {
      if (this.vipProgress.member_progress_type == 2) {
        return (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
      } else if (this.vipProgress.member_progress_type == 3) {
        return (this.vipProgress.current_rollover_progress / this.vipProgress.required_account_rollover) * 100
      }
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    currentLvlCode() {
      this.dMemberLvl = parseInt(this.vipProgress.current_level_name.split(' ')[1])
      return this.vipProgress.current_level_name.split(' ')[1]
      // return 28
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  },
  watch: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    bonusList() {
      try {
        let bonusList = _.cloneDeep(this.$store.state.bonus.bonusList)
        let currentMemberGroup = this.vipProgress.current_level_name
        if (typeof bonusList != 'undefined' && bonusList.length > 0) {
          let releaseTierBonus = bonusList.find(x => x.useReleaseTiers == 1)
          if (releaseTierBonus != null) {
            let selectedApplyBonusMemberGroup = releaseTierBonus.memberGroup.find(x => x.member_group.toLowerCase() == currentMemberGroup.toLowerCase())
            if (selectedApplyBonusMemberGroup != null) {
              this.bonusPercentage = '(' + selectedApplyBonusMemberGroup.percentage_given + '%' + ')'
            }
          }
        }
      } catch (err) {
        this.bonusPercentage = ''
      }
    },
    applyComplete() {
      if (this.$store.state.bonus.vipBonusApplyResult.success) {
        window.alert('VIP Bonus apply status: ' + this.$store.state.bonus.vipBonusApplyResult.success)
        this.$store.dispatch(`${VIP_BONUS_RESET}`)
        this.getVipApplicability()
      }
    },
    vipClaimComplete() {
      if (this.$store.state.bonus.vipProgressClaimResult.complete) {
        this.showVipClaimProgress(this.$store.state.bonus.vipProgressClaimResult)
      }
    },
    vipRewardsSummaryData() {
      this.renderPage()
      // this.changePage(1)
    },
    alertShow() {
      if (!this.alertShow) {
        this.alertSuccess = ''
        this.alertMessage = ''
      }
    }
  },
  created() {
    this.metaTag()
    this.getVipApplicability()
    this.getVipProgress()
    this.getVipRewardsSummary()
    this.getAvailableBonus()
  },
  methods: {
    metaTag() {
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD|en-IN|hi-IN|en-NP|ne-NP|en-PK|ur-PK)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      const Linksenin = `https://${domain}/en-IN${cleanPath}`
      const Linksenhi = `https://${domain}/hi-IN${cleanPath}`
      const Linksenennp = `https://${domain}/en-NP${cleanPath}`
      const Linksennenp = `https://${domain}/ne-NP${cleanPath}`
      const Linksenpk = `https://${domain}/en-PK${cleanPath}`
      const Linksenur = `https://${domain}/ur-PK${cleanPath}`

      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
      uiHelper.setHreflangLinksenin(Linksenin)
      uiHelper.setHreflangLinkshi(Linksenhi)
      uiHelper.setHreflangLinksennp(Linksenennp)
      uiHelper.setHreflangLinksnenp(Linksennenp)
      uiHelper.setHreflangLinksenpk(Linksenpk)
      uiHelper.setHreflangLinksur(Linksenur)
    },
    calculateTimelineColor(targetPage) {
      let vipLevel = parseInt(this.currentLvlCode)
      let colorLevel = vipLevel % 10
      let memberLvlPage = Math.ceil(vipLevel / 10)

      //over lv 10 , > first page
      if (colorLevel == 0 && memberLvlPage == targetPage) {
        //current page last item/lvl = full page color line
        this.dtimelineMemberLvl = this.dtimelineMemberLvl
      } else {
        //x.1 - x.9 , y = 1 - 9
        // x page , y level
        if (memberLvlPage == targetPage) {
          //member lvl within curreng page's lv ,display target lvl color line
          this.dtimelineMemberLvl = colorLevel
        } else if (memberLvlPage < targetPage) {
          //over member lvl
          this.dtimelineMemberLvl = 0
        } else if (memberLvlPage > targetPage) {
          //memberlvl higher than current page's lv = full page color line
          this.dtimelineMemberLvl = 11
        }
      }
    },
    getAvailableBonus() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${BONUS_LIST}`)
      }
    },
    getVipApplicability() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${VIP_BONUS_CHECK}`)
      }
    },
    getVipProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_GET_VIP_PROGRESS)
      }
    },
    getVipRewardsSummary() {
      this.$store.dispatch(VIP_REWARDS_SUMMARY)
    },
    renderPage() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.pagination.totalPage = Math.ceil(this.vipRewardsSummaryData.length / this.searchCriteria.mobilePageSize)
      } else {
        this.pagination.totalPage = Math.ceil(this.vipRewardsSummaryData.length / this.searchCriteria.pageSize)
      }
      this.searchCriteria.pageNumber = 1
      this.changePage(1, true)
    },
    changePage(targetPage, isFirstLoad = false) {
      //normal change on pagination
      if (isFirstLoad && this.isLoggedIn) {
        //first load and logged in , nav to member level's page
        let memberPage = this.currentLvlCode % 6 == 0 ? this.currentLvlCode / 6 : Math.floor(this.currentLvlCode / 6) + 1
        this.searchCriteria.pageNumber = memberPage
        this.pagination.currentPage = memberPage
        this.$nextTick(() => {
          this.scrollToMemberLvl()
        })
      } else {
        //normal change on pagination
        this.scrollToLeftMobile()
        // this.calculateTimelineColor(targetPage)

        this.searchCriteria.pageNumber = targetPage
      }

      if (this.$vuetify.breakpoint.xsOnly) {
        this.currrentVipSummary = this.vipRewardsSummaryData.slice(
          (this.searchCriteria.pageNumber - 1) * this.searchCriteria.mobilePageSize,
          this.searchCriteria.pageNumber * this.searchCriteria.mobilePageSize
        )
      } else {
        this.currrentVipSummary = this.vipRewardsSummaryData.slice((this.searchCriteria.pageNumber - 1) * this.searchCriteria.pageSize, this.searchCriteria.pageNumber * this.searchCriteria.pageSize)
      }
    },
    scrollToLeftMobile() {
      console.log('scrollToLeftMobile:')
      if (this.$vuetify.breakpoint.smAndDown) {
        let element = document.getElementById('betting-pass-prizes-row')
        element.scrollTo({ behavior: 'smooth', left: 0 })
      }
    },
    scrollToMemberLvl() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        let currentId = this.currentLvlCode % this.searchCriteria.mobilePageSize == 0 ? this.searchCriteria.mobilePageSize : this.currentLvlCode % this.searchCriteria.mobilePageSize
        let element = document.getElementById('prize_' + currentId)
        let prizeRow = document.getElementById('betting-pass-prizes-row')
        let htmlDoc = document.getElementsByTagName('html')[0]
        console.log('element prize id :', 'prize_' + currentId)
        if (htmlDoc && prizeRow && element) {
          // element.scrollIntoView({behavior:'smooth',block: 'center',inline: 'center'})
          htmlDoc.scrollTo({ top: prizeRow.offsetHeight, behavior: 'smooth' })
          prizeRow.scrollTo({ left: element.offsetLeft })

          // prizeRow.scrollTo({left: element.offsetsLeft, behavior: 'smooth'})
        }
      }
    },
    applyVipBonus() {
      const selectedBonusId = this.$store.state.bonus.vipBonusCheckResult.data.bonusId
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        params: {
          bonusId: selectedBonusId
        }
      })
    },
    goToDepost() {
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    claimVipProgress() {
      console.log('claim vip progress')
      this.getVipApplicability()
      if (this.isApplicable) {
        this.applyVipBonus()
      } else {
        this.dispatchVipProgress()
      }
    },
    dispatchVipProgress() {
      this.$store.dispatch(VIP_CLAIM_REWARD)
    },
    showVipClaimProgress(result) {
      if (result.success) {
        this.openAlert(true, locale.getMessage(`message.vipBonusSuccess`))
      } else {
        if (result.code == -2) {
          this.openAlert(false, locale.getMessage(`message.vipBonusNoUnclaimedBonus`))
        } else {
          this.openAlert(false, locale.getMessage(`message.vipBonusFailed`))
        }
      }
      this.$store.dispatch(VIP_RESET_CLAIM)
      this.getVipProgress()
      this.getVipApplicability()
    },
    getDisplayIcon(reward) {
      switch (reward.reward_type) {
        case 'COINS':
          return this.getCoinPath()
        case 'GIFT':
          return reward.reward_gift ? reward.reward_gift.imgUrl : ''
        case 'BONUS':
          return this.getGiftPath()
      }
    },
    // hard code asset path
    getCoinPath() {
      return 'https://jiliwin.9terawolf.com/cms/babuVip/vip-reward-icon.png'
    },
    getGiftPath() {
      return 'https://jiliwin.9terawolf.com/cms/babuVip/vip-reward-gift.png'
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER,
        params: { lang: this.$route.params.lang }
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    },
    reminderDialog() {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.Confirmation`)
      dialog.message.push(locale.getMessage(`message.vipSpecialBonusRedeemReminder`))
      dialog.button.push({
        title: locale.getMessage(`label.ok`),
        action: () => this.dispatchVipProgress()
      })
      dialog.button.push({
        title: locale.getMessage(`button.cancel`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    }
  }
}
</script>

<style lang="scss">
.betting-pass-banner-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 320px;
  max-height: 320px;
  position: relative;

  @media screen and (max-width: 959px) {
    min-height: 220px !important;
    max-height: 220px !important;
  }

  .betting-pass-tiger {
    width: 26%;
    position: absolute;
    left: -48px;
    bottom: -18%;

    @media screen and (max-width: 1800px) {
      bottom: -6%;
    }

    @media screen and (max-width: 1300px) {
      left: -13%;
      bottom: -6%;
    }


  }

  .betting-pass-banner {
    width: 85%;
    height: 100%;
    max-width: 930px;
    max-height: 320px;
    margin-right: 20px;
    padding: 20px 16px;
    right: 0;
    position: absolute;
    background-size: cover;
    background-position-x: right;
    border-radius: 20px;

    @media screen and (max-width: 959px) {
      width: 100% !important;
      margin-right: unset !important;
      max-height: 220px;
      display: flex;

      .betting-pass-content {
        width: auto !important;
      }
    }

    @media screen and (max-width: 1300px) {
      align-content: center;
      width: 93%;
      height: 320px;
    }

    .betting-pass-content {
      width: 500px;
      span {
        display: flex;
        color: white;
      }

      .title-1 {
        font-size: 30px;
        font-weight: bold;

        @media screen and (max-width: 1300px) {
          font-size: 25px;
        }

        @media screen and (max-width: 959px) {
        }
      }

      .title-2 {
        font-size: 22px;
        font-weight: bold;

        @media screen and (max-width: 599px) {
          font-size: 0.8rem;
        }

        @media screen and (min-width: 600px) and (max-width: 1300px) {
          font-size: 19px;
        }
      }

      .content {
        font-size: 14px;

        @media screen and (max-width: 1300px) {
          font-size: 13px;
        }
      }
    }
  }
}

.vip-level {
  height: 68px;
  font-size: 30px;
  align-content: center;
  background-image: url('/static/image/betting-pass/vip-level-bg.png');
  background-position: center;
}

.vip-progress-text {
  display: flex;
  color: white;
  font-size: 12px;

  &.mobile {
    padding-left: 1rem;
    padding-bottom: 1.5rem;
  }
}

.vip-progress-bar-text {
  color: white;
  font-size: 12px;
  float: right;
}

.vip-current-level-text {
  color: white;
  font-size: 12px;
}

.vip-next-level-text {
  color: white;
  font-size: 12px;
  float: right;
}

.betting-pass-level-container {
  position: relative;
}

.betting-pass-treasure {
  width: 188px;
  position: absolute;
  z-index: 2;
  right: -38px;
  bottom: -24%;

  @media screen and (max-width: 1800px) {
    right: -60px;
  }

  @media screen and (max-width: 1700px) {
    right: -80px;
  }

  @media screen and (max-width: 1500px) {
    right: -120px;
  }
}

.vip-card {
  .betting-pass-header-details {
    @media screen and (max-width: 959px) {
      gap: 1.5rem 0;
      flex-direction: column;
      margin: 0 24px !important;
    }
  }

  .betting-pass-summary-table {
    background: transparent;

    .betting-pass-reward-container {
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      margin: 24px 8px 0;
      padding: 8px 0;
      color: white;
      background-color: #000000a6;
      justify-content: space-around;
      height: 300px;

      @media screen and (max-width: 959px) {
        height: auto;
      }
      @media screen and (min-width: 960px) and (max-width: 1300px) {
        height: 115px;
      }

      @media screen and (min-width: 1301px) and (max-width: 1999px) {
        height: 180px;
      }

      @media screen and (min-width: 2000px) and (max-width: 2500px) {
        height: 250px;
      }

      .betting-pass-reward-img {
        width: 44%;
        margin: 4px 0;
        align-self: center;
        @media screen and (max-width: 599px) {
          height: 75px;
        }

        @media screen and (min-width: 600px) and (max-width: 959px) {
          width: auto;
          height: 130px;
        }
      }

      .betting-pass-reward-level-text {
        font-size: 16px;
        text-align: center;
        color: var(--v-newMobilePrimary-base);
      }

      .betting-pass-reward-divider {
        height: 1px;
        margin: 2px 0;
        background-color: #575757;
      }

      .betting-pass-reward-text {
        font-size: 16px;
        text-align: center;
        align-content: center;
      }

      .betting-pass-requirements-text {
        height: 36px;
        font-size: 14px;
        text-align: center;
        align-content: center;
        margin-top: 4px;

        @media screen and (min-width: 960px) {
          height: 41px;
        }
      }
    }

    .betting-pass-reward-button {
      width: 100% !important;
      height: 40px !important;
      font-size: 0.85rem;
      text-transform: uppercase;

      @media screen and (max-width: 959px) {
        height: 35px !important;
      }
    }

    .claimed-betting-pass-reward-button {
      font-size: 1rem;
      font-weight: bolder !important;
      background-color: #FED32180 !important;
      cursor: default;
    }
  }

  .mobile-lvl-card {
    background-color: #000000;
    box-shadow: 0px 0px 4px var(--v-newMobilePrimary-base) !important;
    transform: skewX(-15deg);
    -webkit-transform: skewX(-15deg);
    -moz-transform: skewX(-15deg);
    -ms-transform: skewX(-15deg);
    -o-transform: skewX(-15deg);
    height: 50px;
    width: 75px;
    color: #ffffff;
    text-align: center;
    padding-top: 5px;
    .lvl-title {
      padding: unset;
    }
  }
  .mobile-progress-header-div {
    display: flex;
    color: #ffffff;
    margin-left: 30px;
    margin-right: 20px;
    gap: 0px 10px;
    gap: 0px 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .v-timeline:after {
    bottom: 0;
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    width: 2px;
    left: calc(45% - 1px);
    background: #474747;
  }
  .resetInclineStyle {
    -webkit-transform: skewX(15deg);
    transform: skewX(15deg);
    -webkit-transform: skewX(15deg);
    -moz-transform: skewX(15deg);
    -ms-transform: skewX(15deg);
    -o-transform: skewX(15deg);
  }
  .fulfilled {
    box-shadow: 0px 0px 4px #ffce01 !important;
  }

  .fulfilled-claimBtn {
    background-color: var(--v-newMobilePrimary-base);
    color: #000000;
    opacity: 0.5;
  }

  .giftPrize-size {
    height: 4rem !important;
    margin-top: -22px;
  }

  .currentLvl-claimBtn {
    opacity: unset !important;
  }
  .claimable-btn {
    opacity: unset !important;
  }

  .mobile-vip-header {
    height: 100px;
    border-bottom: 2px solid var(--v-newMobilePrimary-base);
    //opacity: .5;
  }
  .v-timeline {
    height: max-content;
  }
  .theme--light.v-timeline::before {
    background-color: var(--v-newMobilePrimary-base);
    left: calc(45% - 1px) !important;
  }
  .v-timeline-item {
    padding-bottom: 50px !important;
  }
  .v-timeline-item__dot {
    background: transparent !important;
  }
  .v-timeline-item__dot {
    width: 200px;
    .v-timeline-item__inner-dot {
      width: inherit;
      margin: 4px 0 0 4px;
      .prizename-card {
        background-color: #000000;
        color: #ffffff;
        width: inherit;
        height: 60px;
        border-radius: unset;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: skewX(-15deg);
        -webkit-transform: skewX(-15deg);
        -moz-transform: skewX(-15deg);
        -ms-transform: skewX(-15deg);
        -o-transform: skewX(-15deg);
        .prizename-span {
          -webkit-transform: skewX(15deg);
        }
      }
    }
  }
  .prizeImg.v-card {
    width: 65px;
    height: 60px;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: skewX(-15deg);
    -webkit-transform: skewX(-15deg);
    -moz-transform: skewX(-15deg);
    -ms-transform: skewX(-15deg);
    -o-transform: skewX(-15deg);
    color: var(--v-newMobilePrimary-base);
    flex-direction: column;
    .prizeIndex-span {
      width: 100%;
      margin-right: 15px;
    }
  }
}

.claim-btn {
  color: #9b9b9b;
  height: 60px;
  width: 113px;
  background-color: #474747;
  transform: skewX(-15deg);
  -webkit-transform: skewX(-15deg);
  -moz-transform: skewX(-15deg);
  -ms-transform: skewX(-15deg);
  -o-transform: skewX(-15deg);
  .v-card__text {
    padding: unset;
  }
  display: flex;
  align-items: center;
  justify-content: center;
}

.vip-timeline-wrapper {
  display: flex;
  justify-content: center;
  height: 57vh;
  overflow-y: scroll;
  //margin: 15px 50px 15px 50px;
}
.profile-alert-success {
  .v-icon {
    color: #25b34b;
  }
}

.profile-alert-failed {
  .v-icon {
    color: #dc2d2d;
  }
}

.vip-summary-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;

  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }

  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }

  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }

  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}

.vip-card {
  background-color: transparent !important;

  .vip-progress-card {
    width: 272px;
    height: 100%;
    max-height: 320px;
    background-color: #1c1c1c;
    border: 1px solid white;
    border-radius: 20px;

    &.logged-in {
      display: flex;
      flex-direction: column;
    }

    .progress-bar-details {
      padding-top: 24px;
    }

    .vip-progress-status-title {
      background-image: linear-gradient(to left, #fddd04, #fdb504);
      padding: 1px 4px;
    }

    .betting-pass-register-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
      color: white !important;
      background-color: #0080f6;
      @media screen and (max-width: 959px) {
        height: 35px !important;
      }
    }

    .betting-pass-login-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
    }

    .betting-pass-deposit-button {
      width: 100% !important;
      height: 40px !important;
      margin: 4px 0 !important;
      background-color: #0080f6;
      border-radius: 12px;
    }
  }

  .icon-size {
    height: 2em;
  }

  .vip-process-bar-icon {
    border: 10px solid #262626;
    z-index: 1;

    img {
      padding: 6px;
    }
  }

  .vip-progress-bar {
    background-color: #acacac !important;
    //border: 10px solid #262626;
    border-radius: 20px;
    margin-top: 8px;

    .v-progress-linear__background {
      background-color: #acacac !important;
      border-color: #acacac !important;
      opacity: 1 !important;
    }

    .v-progress-linear__determinate {
      background-image: linear-gradient(to left, #fddd04, #fdb504) !important;
    }
  }

  .vip-summary-table {
    background-color: #262626;
    border-radius: 20px 20px 0px 0px !important;

    .content {
      padding: 12px;
    }
  }

  .vip-summary-table-content {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px 0px 20px 20px !important;

    .content {
      padding: 12px;
    }
  }

  .vip-summary-table-mobile {
    background-color: #262626;
    border-radius: 0px;
    padding: 4px;

    .content {
      padding: 4px;
    }
  }

  .vip-summary-table-content-mobile {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px;
    padding: 8px 4px;

    .content {
      padding: 4px;
    }
  }

  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: #333333 !important;
    color: #575757 !important;
    border: 1px solid #575757 !important;
  }
}

.vip_summary_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 12px;
    }
  }

  .v-pagination__more {
    color: var(--v-newMobilePrimary-base);
  }
}

.selected-level {
  background-color: #0c2aab !important;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.container {
  position: relative;
  text-align: center;
}

.embedded-register-button {
  width: 120px !important;
  padding: 4px !important;
}

.embedded-login-button {
  width: 110px !important;
}

@media (max-width: 1024px) {
  .vip-card {
    font-size: 13px;
  }
}

@media (max-width: 959px) {
  .betting-pass-prizes-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    .mobile-prize-card {
      min-width: 25dvw;
    }
  }

  .vip-progress-card {
    width: 100% !important;

    .deposit-desc-btn {
      padding-bottom: 8px;
    }

    .mobile-logged-details {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      .mobile-logged-level {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }

      .progress-bar-details {
        padding-top: unset !important;
      }

      .mobile-gutter {
        margin: 0 !important;
        width: 100%;
      }

      .progress-node-desc {
        padding-top: 8px;
      }
    }
  }

  .theme--light.v-pagination .v-pagination__navigation {
    background-color: transparent !important;
    color: #ffffff !important;
  }
  .theme--dark.v-pagination .v-pagination__navigation {
    background-color: transparent !important;
    color: #ffffff !important;
  }
  .mobile-vip-header {
    margin-top: unset !important;
  }
  .vip-card {
    height: inherit;
    .icon-size {
      height: 44px;
      //margin-bottom:30px;
    }
    .v-timeline:before {
      height: 95% !important;
      /*start yellow line after the first level box*/
      top: 30px !important;
    }
    .v-timeline-item__body {
      padding-left: 50px;
    }
    .v-timeline-item__opposite {
      padding-right: 50px;
    }

    .vip_summary_pagination .v-pagination li button {
      font-size: 1.2rem;
      height: 32px;
    }
  }

  .vip-card {
    background-color: #333333 !important;
  }
  .theme--dark.v-pagination .v-pagination__navigation {
    background-color: transparent;
  }
  .vip-mobile-login-button {
    width: 100% !important;
    height: 35px !important;
    font-size: 12px !important;
  }
  .vip-mobile-register-button {
    width: 120px !important;
  }

  //  mobile layout
  .v-pagination {
    margin: 15px 0px;
    li {
      button {
        border-radius: 50% !important;
        min-height: 31px !important;
        min-width: 31px !important;
        margin-right: 10px;
      }
    }
  }
  .theme--dark.v-pagination.v-pagination__item.v-pagination__item--active {
    background-color: #474747 !important;
    color: var(--v-newMobilePrimary-base) !important;
  }

  .v-pagination__item {
    background-color: #474747 !important;
    color: var(--v-newMobilePrimary-base) !important;
    &.v-pagination__item--active {
      background-color: var(--v-newMobilePrimary-base) !important;
      color: #000000 !important;
    }
  }
  .v-pagination__item.v-pagination__item--active {
    background-color: var(--v-newMobilePrimary-base) !important;
    color: #000000 !important;
  }
}
@media (orientation: landscape) {
  .vip-timeline-wrapper {
    height: 35vh;
  }
  .mobile-vip-header {
    height: 60px !important;
  }

  .theme--light.v-timeline::before {
    left: calc(50% - 25px) !important;
  }
  .v-timeline::after {
    left: calc(50% - 25px) !important;
  }
}

$timelineItemHeight_599: 55px;

@media (max-width: 959px) {
  .vip-card {
    font-size: 12px;

    .vip-progress-card {
      border-radius: 20px;

      .vip-progress-status-title {
        background-image: linear-gradient(to left, #fddd04, #fdb504);
        padding: 1px 4px;
      }
    }

    .icon-size {
      height: 3.5em;
    }

    .vip-process-bar-icon {
      border: 8px solid #262626;
      z-index: 1;
    }

    .vip-progress-bar {
      background-color: #111111 !important;
      border-radius: 20px;
      margin-top: 8px;

      .v-progress-linear__background {
        background-color: #111111 !important;
        border-color: #111111 !important;
        opacity: 1 !important;
      }

      .v-progress-linear__determinate {
        background-image: linear-gradient(to left, #fddd04, #fdb504) !important;
      }
    }

    .v-btn.dialog-button {
      width: inherit !important;
      height: auto !important;
      font-size: 12px !important;
    }

    .v-timeline-item__opposite {
      padding-right: 8px;
    }
    .v-timeline-item {
      padding-bottom: 30px !important;
    }

    .theme--light.v-timeline::before {
      background-color: var(--v-newMobilePrimary-base);
      left: calc(50% - 15px) !important;
    }
    .v-timeline::after {
      left: calc(50% - 15px) !important;
    }

    .v-timeline-item__body {
      padding-left: 15px;
    }
    .v-timeline-item__dot {
      width: 145px;
      .v-timeline-item__inner-dot {
        width: inherit;
        .prizename-card {
          width: inherit;
          height: $timelineItemHeight_599;
        }
      }
    }
    .prizeImg.v-card {
      height: $timelineItemHeight_599;
      .icon-size {
        height: 2.8rem;
      }
      .prizeIndex-span {
        font-size: 0.7rem;
      }
    }
    .claim-btn {
      height: $timelineItemHeight_599 !important;
      width: 90px !important;
    }
  }
}

@media (max-width: 599px) {
}

// xtra small device
@media (max-width: 499px) {
  .vip-progress-card {
    .mobile-logged-details {
      .mobile-logged-level {
        flex: 0 0 25.6666666667% !important;
        max-width: 25.666667% !important;
      }
    }
  }

  .vip-card {
    .betting-pass-summary-table {
      .betting-pass-prizes-row {
        .mobile-prize-card {
          min-width: 34dvw;
          .betting-pass-reward-container {
            height: 136px;
            margin: 0 4px;
            justify-content: space-evenly;
            .betting-pass-reward-level-text,
            .betting-pass-reward-text {
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 399px) {
  .vip-card {
    .betting-pass-summary-table {
      .betting-pass-prizes-row {
        .mobile-prize-card {
          min-width: 35dvw;
          .betting-pass-reward-container {
            //height: 145px;
            .betting-pass-reward-img {
            }
          }
        }
      }
    }
  }
}
</style>
